import { useCallback } from "react";
import { useSetRecoilState } from "recoil";

import { FirebaseStore, firebaseStore } from "store/firebaseStore";

const useFirebaseStore = () => {
  const setFirebaseStore = useSetRecoilState(firebaseStore);

  const setAppReady = useCallback(
    (ready: boolean) => setFirebaseStore((prev) => ({ ...prev, appReady: ready })),
    [setFirebaseStore]
  );

  const setRemoteConfig = useCallback(
    (remoteConfig: FirebaseStore["remoteConfig"]) =>
      setFirebaseStore((prev) => ({ ...prev, remoteConfig: remoteConfig })),
    [setFirebaseStore]
  );

  const setRequestReady = useCallback(
    (ready: boolean) => setFirebaseStore((prev) => ({ ...prev, requestReady: ready })),
    [setFirebaseStore]
  );

  const setAuthReady = useCallback(
    (ready: boolean) => setFirebaseStore((prev) => ({ ...prev, authReady: ready })),
    [setFirebaseStore]
  );

  return { setAppReady, setRemoteConfig, setRequestReady, setAuthReady };
};

export default useFirebaseStore;
